import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Image,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  FormLabel,
  useDisclosure,
  useToast,
  Spinner,
  Text,
  InputGroup,
  InputLeftElement,
  HStack,
  SimpleGrid,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Card,
  Tooltip,
  Icon,
  Divider,
  Textarea,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Select,
} from '@chakra-ui/react';
import {
  AddIcon,
  EditIcon,
  DeleteIcon,
  InfoIcon,
} from '@chakra-ui/icons';
import axiosInstance from 'axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import { useColorModeValue } from '@chakra-ui/react';
import {
  InfoOutlineIcon,
  EmailIcon,
  PhoneIcon,
  AtSignIcon,
  CloseIcon,
  CheckCircleIcon,
  ArrowUpIcon,
} from '@chakra-ui/icons';
import {
  FaAddressBook,
  FaBuilding,
  FaCity,
  FaClipboardList,
  FaEnvelope,
  FaFilePdf,
  FaHashtag,
  FaInfoCircle,
  FaMapMarkedAlt,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from 'react-icons/fa';
import { MdDevices, MdStreetview, MdUploadFile } from 'react-icons/md';
import { FaFlag, FaGlobe, FaHome } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';

import { MdConfirmationNumber } from 'react-icons/md';
import Swal from 'sweetalert2';
import { notifyApiError, notifyApiErrorAsync } from 'utils/apiFeedback';
import { useUser } from '../../../userContext';

const COMPANY_LOGO_MAX_SIZE_BYTES = 2 * 1024 * 1024;
const COMPANY_LOGO_ALLOWED_TYPES = ['image/png', 'image/jpeg'];
const COMPANY_LOGO_ALLOWED_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
const INDIAN_MOBILE_DIGITS = 10;
const INDIAN_PIN_DIGITS = 6;

const Company = () => {
  const Token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const canManageCompany = userRole === 'companyUser';
  const toast = useToast();
  const { updateLicenseData } = useUser();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const {
    isOpen: isViewOpen,
    onClose: onViewClose,
  } = useDisclosure();
  const [company, setCompany] = useState([]);
  const [addErrors, setAddErrors] = useState({});
  const [editErrors, setEditErrors] = useState({});
  const [editCompany, setEditCompany] = useState({
    name: '',
    email1: '',
    email2: '',
    contact1: '',
    contact2: '',
    limitPerDay: null,
    limitPerYear: null,
    companyRepresentativeName: '',
    nocDetails: {
      nocNumber: '',
      nocExpiry: {
        startDate: '',
        endDate: '',
      },
    },
    nocDocument: null,
    companyLogo: null,
    // aquasenseSalesRepresentative: '',
    // aquasenseIRMUser: '',
    addressLine: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
  });
  const [addCompany, setAddCompany] = useState({
    name: '',
    email1: '',
    email2: '',
    contact1: '',
    contact2: '',
    limitPerDay: null,
    limitPerYear: null,
    companyRepresentativeName: '',
    nocDetails: {
      nocNumber: '',
      nocExpiry: {
        startDate: '',
        endDate: '',
      },
    },
    nocDocument: null,
    companyLogo: null,
    // aquasenseSalesRepresentative: '',
    // aquasenseIRMUser: '',
    addressLine: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
  });
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [loading, setLoading] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [editId, setEditId] = useState('');
  const [addNocFile, setAddNocFile] = useState(null);
  const [editNocFile, setEditNocFile] = useState(null);
  const [addLogoFile, setAddLogoFile] = useState(null);
  const [editLogoFile, setEditLogoFile] = useState(null);
  const [downloadingDocId, setDownloadingDocId] = useState('');
  const modalBg = useColorModeValue('white', 'gray.800');
  const labelColor = useColorModeValue('gray.800', 'gray.300');
  const addmodalheaderBg = useColorModeValue(
    'linear-gradient(90deg,rgb(34, 84, 157) 0%,rgb(60, 129, 159) 50%,rgb(93, 153, 156) 100%)',
    'linear-gradient(90deg,rgb(39, 205, 230) 0%,rgb(81, 198, 224) 50%,rgb(136, 218, 236) 100%)',
  );
  const sectionBg = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.300');
  const nocFileChipBg = useColorModeValue('blue.50', 'whiteAlpha.100');
  const nocFileChipBorder = useColorModeValue('blue.100', 'gray.600');
  const profileBorderColor = useColorModeValue('gray.200', 'gray.700');
  const documentBorderColor = useColorModeValue('gray.100', 'gray.700');
  const logoCircleBg = useColorModeValue('blue.50', 'dark.700');
  const documentIconBg = useColorModeValue('blue.50', 'whiteAlpha.100');

  useEffect(() => {
    getCompany();
  }, [page, rowsPerPage]);

  const getQueryString = (params) => {
    return Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== '')
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
  };

  const buildCompanyFormData = (companyData, nocFile, logoFile) => {
    const formData = new FormData();

    Object.entries(companyData).forEach(([key, value]) => {
      if (
        value === undefined ||
        value === null ||
        key === 'nocDocument' ||
        key === 'companyLogo'
      ) {
        return;
      }

      if (key === 'nocDetails') {
        formData.append(key, JSON.stringify(value));
        return;
      }

      formData.append(key, value);
    });

    if (nocFile) {
      formData.append('nocPdf', nocFile);
    }

    if (logoFile) {
      formData.append('companyLogo', logoFile);
    }

    return formData;
  };

  const isPdfFile = (file) => {
    return (
      file &&
      file.type === 'application/pdf' &&
      file.name?.toLowerCase().endsWith('.pdf')
    );
  };

  const isCompanyLogoFile = (file) => {
    const fileName = file?.name?.toLowerCase() || '';
    const hasAllowedExtension = COMPANY_LOGO_ALLOWED_EXTENSIONS.some((ext) =>
      fileName.endsWith(ext),
    );

    return (
      file &&
      COMPANY_LOGO_ALLOWED_TYPES.includes(file.type) &&
      hasAllowedExtension
    );
  };

  const validateCompanyLogoFile = (file, inputElement) => {
    if (!file) return true;

    if (!isCompanyLogoFile(file)) {
      inputElement.value = '';
      toast({
        title: 'Please upload a PNG, JPG, or JPEG logo',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    if (file.size > COMPANY_LOGO_MAX_SIZE_BYTES) {
      inputElement.value = '';
      toast({
        title: 'Community logo size must be less than 2 MB',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return false;
    }

    return true;
  };

  const normalizeDigits = (value, maxLength) =>
    String(value || '')
      .replace(/\D/g, '')
      .slice(0, maxLength);

  const normalizeMobileInput = (value) =>
    String(value || '')
      .replace(/\D/g, '')
      .replace(/^91(?=\d{10}$)/, '')
      .slice(0, INDIAN_MOBILE_DIGITS);

  const normalizeIndianPinInput = (value) =>
    normalizeDigits(value, INDIAN_PIN_DIGITS);

  const isValidMobile = (value) =>
    normalizeMobileInput(value).length === INDIAN_MOBILE_DIGITS;

  const isValidIndianPin = (value) =>
    normalizeIndianPinInput(value).length === INDIAN_PIN_DIGITS;

  const handleAddNocFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    if (file && !isPdfFile(file)) {
      e.target.value = '';
      setAddNocFile(null);
      toast({
        title: 'Please upload a PDF file',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setAddNocFile(file);
  };

  const handleEditNocFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    if (file && !isPdfFile(file)) {
      e.target.value = '';
      setEditNocFile(null);
      toast({
        title: 'Please upload a PDF file',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setEditNocFile(file);
  };

  const handleAddLogoFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    if (!validateCompanyLogoFile(file, e.target)) {
      setAddLogoFile(null);
      return;
    }

    setAddLogoFile(file);
  };

  const handleEditLogoFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    if (!validateCompanyLogoFile(file, e.target)) {
      setEditLogoFile(null);
      return;
    }

    setEditLogoFile(file);
  };

  const handleAddModalClose = () => {
    setAddNocFile(null);
    setAddLogoFile(null);
    onClose();
  };

  const handleEditModalClose = () => {
    setEditNocFile(null);
    setEditLogoFile(null);
    onEditClose();
  };

  const getCompany = async ({ logoVersion } = {}) => {
    try {
      const queryParams = {
        page: page ? page : 1,
        limit: rowsPerPage,
      };
      const response = await axiosInstance.get(
        `${baseUrl}/company?${getQueryString(queryParams)}`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      if (response) {
        const companyData = response?.data?.data?.data || [];
        const selected = companyData?.[0] || null;
        setCompany(companyData);
        setSelectedCompany(selected);
        if (selected) {
          syncCompanyStorage(selected, { logoVersion });
        }
        setPage(response?.data?.data?.page);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to load companies');
    }
  };

  const handleEdit = (company, event) => {
    setEditId(company?._id);
    setEditNocFile(null);
    setEditLogoFile(null);
    setEditCompany({
      ...editCompany,
      name: company?.name,
      companyId: company.companyId,
      email1: company?.email1,
      email2: company?.email2,
      contact1: company?.contact1,
      contact2: company?.contact2,
      limitPerDay: company?.limitPerDay,
      limitPerYear: company?.limitPerYear,
      nocDetails: company?.nocDetails,
      nocDocument: company?.nocDocument || null,
      companyLogo: company?.companyLogo || null,
      companyRepresentativeName: company?.companyRepresentativeName,
      // aquasenseSalesRepresentative: company?.aquasenseSalesRepresentative?._id,
      // aquasenseIRMUser: company?.aquasenseIRMUser?._id,
      addressId: company?.address?._id,
      addressLine: company?.address?.addressLine,
      city: company?.address?.city,
      state: company?.address?.state,
      country: company?.address?.country,
      zipcode: company?.address?.zipcode,
    });
    onEditOpen();
  };

  const handleSave = async () => {
    try {
      let temp = {};

      if (!editCompany.name) temp.name = 'Community name is required';
      if (!editCompany.email1) temp.email1 = 'Primary email is required';
      if (!editCompany.contact1) temp.contact1 = 'Primary contact is required';
      else if (!isValidMobile(editCompany.contact1))
        temp.contact1 = 'Primary contact must be exactly 10 digits';
      if (editCompany.contact2 && !isValidMobile(editCompany.contact2))
        temp.contact2 = 'Secondary contact must be exactly 10 digits';
      if (!editCompany.addressLine) temp.address = 'Address is required';
      if (!editCompany.zipcode) temp.zipcode = 'Zipcode is required';
      else if (!isValidIndianPin(editCompany.zipcode))
        temp.zipcode = 'Zipcode must be exactly 6 digits';
      if (!editCompany?.nocDetails?.nocNumber)
        temp.nocNumber = 'NOC number is required';
      if (!editCompany?.nocDetails?.nocExpiry?.startDate)
        temp.nocStartDate = 'NOC start period is required';
      if (!editCompany?.nocDetails?.nocExpiry?.endDate)
        temp.nocEndDate = 'NOC stop period is required';
      if (!editCompany?.limitPerDay)
        temp.dailyLimit = 'Daily abstraction limit is required';
      if (!editCompany?.limitPerYear)
        temp.yearlyLimit = 'Yearly abstraction limit is required';

      setEditErrors(temp);

      if (Object.keys(temp).length > 0) return;
      // return
      setLoading(true);
      const normalizedCompany = {
        ...editCompany,
        contact1: normalizeMobileInput(editCompany.contact1),
        contact2: normalizeMobileInput(editCompany.contact2),
        zipcode: normalizeIndianPinInput(editCompany.zipcode),
      };
      const formData = buildCompanyFormData(
        normalizedCompany,
        editNocFile,
        editLogoFile,
      );
      const response = await axiosInstance.put(
        `${baseUrl}/company/update/${editId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      if (response) {
        const updatedCompany =
          response?.data?.data?.data || response?.data?.data || null;
        const logoVersion = editLogoFile ? Date.now() : undefined;
        syncCompanyStorage(
          {
            ...(selectedCompany || {}),
            ...(updatedCompany || {}),
          },
          { logoVersion },
        );
        setLoading(false);
        handleEditModalClose();
        toast({
          title: 'Updated successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        getCompany({ logoVersion });
      }
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to update community');
    }
  };

  const handleAddCompany = async () => {
    try {
      let temp = {};

      if (!addCompany.name) temp.name = 'Community name is required';
      if (!addCompany.email1) temp.email1 = 'Primary email is required';
      if (!addCompany.contact1) temp.contact1 = 'Primary contact is required';
      else if (!isValidMobile(addCompany.contact1))
        temp.contact1 = 'Primary contact must be exactly 10 digits';
      if (addCompany.contact2 && !isValidMobile(addCompany.contact2))
        temp.contact2 = 'Secondary contact must be exactly 10 digits';
      if (!addCompany.addressLine) temp.address = 'Address is required';
      if (!addCompany.zipcode) temp.zipcode = 'Zipcode is required';
      else if (!isValidIndianPin(addCompany.zipcode))
        temp.zipcode = 'Zipcode must be exactly 6 digits';
      if (!addCompany?.nocDetails?.nocNumber)
        temp.nocNumber = 'NOC number is required';
      if (!addCompany?.nocDetails?.nocExpiry?.startDate)
        temp.nocStartDate = 'NOC start period is required';
      if (!addCompany?.nocDetails?.nocExpiry?.endDate)
        temp.nocEndDate = 'NOC stop period is required';
      if (!addCompany?.limitPerDay)
        temp.dailyLimit = 'Daily abstraction limit is required';
      if (!addCompany?.limitPerYear)
        temp.yearlyLimit = 'Yearly abstraction limit is required';

      setAddErrors(temp);
      if (Object.keys(temp).length > 0) return;

      setLoading(true);
      const normalizedCompany = {
        ...addCompany,
        contact1: normalizeMobileInput(addCompany.contact1),
        contact2: normalizeMobileInput(addCompany.contact2),
        zipcode: normalizeIndianPinInput(addCompany.zipcode),
      };
      const formData = buildCompanyFormData(
        normalizedCompany,
        addNocFile,
        addLogoFile,
      );
      const response = await axiosInstance.post(
        `${baseUrl}/company/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      if (response) {
        const createdCompany =
          response?.data?.data?.data || response?.data?.data || null;
        syncCompanyStorage(createdCompany);
        setLoading(false);
        handleAddModalClose();
        toast({
          title: 'Community added successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        getCompany();
        setAddCompany({
          name: '',
          email1: '',
          email2: '',
          contact1: '',
          contact2: '',
          limitPerDay: null,
          limitPerYear: null,
          companyRepresentativeName: '',
          nocDetails: {
            nocNumber: '',
            nocExpiry: {
              startDate: '',
              endDate: '',
            },
          },
          nocDocument: null,
          companyLogo: null,
          // aquasenseSalesRepresentative: '',
          // aquasenseIRMUser: '',
          addressLine: '',
          city: '',
          state: '',
          country: '',
          zipcode: '',
        });
        setAddLogoFile(null);
      }
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to add community');
    }
  };

  const handleEditChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'contact1' || name === 'contact2') {
      value = normalizeMobileInput(value);
    } else if (name === 'zipcode') {
      value = normalizeIndianPinInput(value);
    }

    if (name === 'nocNumber') {
      setEditCompany((prev) => ({
        ...prev,
        nocDetails: {
          ...prev.nocDetails,
          [name]: value,
        },
      }));
      return;
    }

    if (name === 'startDate' || name === 'endDate') {
      setEditCompany((prev) => ({
        ...prev,
        nocDetails: {
          ...prev.nocDetails,
          nocExpiry: {
            ...prev.nocDetails.nocExpiry,
            [name]: value,
          },
        },
      }));
      return;
    }
    setEditCompany({ ...editCompany, [name]: value });
  };

  const handleAddChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'contact1' || name === 'contact2') {
      value = normalizeMobileInput(value);
    } else if (name === 'zipcode') {
      value = normalizeIndianPinInput(value);
    }

    if (name === 'nocNumber') {
      setAddCompany((prev) => ({
        ...prev,
        nocDetails: {
          ...prev.nocDetails,
          [name]: value,
        },
      }));
      return;
    }

    if (name === 'startDate' || name === 'endDate') {
      setAddCompany((prev) => ({
        ...prev,
        nocDetails: {
          ...prev.nocDetails,
          nocExpiry: {
            ...prev.nocDetails.nocExpiry,
            [name]: value,
          },
        },
      }));
      return;
    }

    setAddCompany({ ...addCompany, [name]: value });
  };

  const profileCompany = selectedCompany || company?.[0] || null;

  const getValue = (value) => {
    if (value === undefined || value === null || value === '') return 'N/A';
    return value;
  };

  const formatDate = (value) => {
    if (!value) return 'N/A';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-GB');
  };

  const formatAddress = (address) =>
    [
      address?.addressLine,
      address?.city,
      address?.state,
      address?.country,
      address?.zipcode,
    ]
      .filter(Boolean)
      .join(', ') || 'N/A';

  const getCompanyLogoUrl = (companyData, versionOverride) => {
    if (!companyData?._id || !companyData?.companyLogo?.relativePath) {
      return '';
    }

    const version =
      versionOverride ||
      companyData?.companyLogo?.updatedAt ||
      companyData?.updatedAt ||
      companyData?.companyLogo?.relativePath ||
      '';

    return `${baseUrl}/company/logo/${companyData._id}${
      version ? `?v=${encodeURIComponent(version)}` : ''
    }`;
  };

  const getNocDownloadFileName = (companyData, response) => {
    const disposition = response?.headers?.['content-disposition'];
    const fileName = disposition?.match(/filename="?([^";]+)"?/i);

    return (
      fileName?.[1] ||
      companyData?.nocDocument?.originalName ||
      `${companyData?.name || 'Community'}_NOC.pdf`
    );
  };

  const handleDownloadNocDocument = async (companyData) => {
    if (!companyData?._id || !companyData?.nocDocument?.relativePath) {
      toast({
        title: 'NOC document is not available',
        status: 'info',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setDownloadingDocId(companyData._id);
      const response = await axiosInstance.get(
        `${baseUrl}/company/noc/${companyData._id}/download`,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          responseType: 'blob',
          skipGlobalErrorToast: true,
        },
      );

      const blob = new Blob([response.data], {
        type: response.headers?.['content-type'] || 'application/pdf',
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = getNocDownloadFileName(companyData, response);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      await notifyApiErrorAsync(error, toast, 'Unable to download NOC document');
    } finally {
      setDownloadingDocId('');
    }
  };

  const clearCompanyStorage = () => {
    [
      'companyId',
      'companyName',
      'nocNumber',
      'nocStartDate',
      'nocEndDate',
      'limitPerDay',
      'limitPerYear',
      'nocPdfFileName',
      'companyLogoUrl',
      'borewellCount',
    ].forEach((key) => localStorage.removeItem(key));
    updateLicenseData({
      nocNumber: '',
      nocStartDate: '',
      nocEndDate: '',
      limitPerDay: '',
      limitPerYear: '',
      nocPdfFileName: '',
      borewellCount: '',
      companyLogoUrl: '',
    });
  };

  const syncCompanyStorage = (companyData, { logoVersion } = {}) => {
    if (!companyData?._id) return;
    const companyLogoUrl = getCompanyLogoUrl(companyData, logoVersion);

    localStorage.setItem('companyId', companyData._id);
    localStorage.setItem('companyName', companyData.name || '');
    localStorage.setItem(
      'nocNumber',
      companyData?.nocDetails?.nocNumber || '',
    );
    localStorage.setItem(
      'nocStartDate',
      companyData?.nocDetails?.nocExpiry?.startDate || '',
    );
    localStorage.setItem(
      'nocEndDate',
      companyData?.nocDetails?.nocExpiry?.endDate || '',
    );
    localStorage.setItem('limitPerDay', companyData?.limitPerDay ?? '');
    localStorage.setItem('limitPerYear', companyData?.limitPerYear ?? '');
    localStorage.setItem(
      'nocPdfFileName',
      companyData?.nocDocument?.originalName || '',
    );
    localStorage.setItem('companyLogoUrl', companyLogoUrl);
    updateLicenseData({
      nocNumber: companyData?.nocDetails?.nocNumber || '',
      nocStartDate: companyData?.nocDetails?.nocExpiry?.startDate || '',
      nocEndDate: companyData?.nocDetails?.nocExpiry?.endDate || '',
      limitPerDay: companyData?.limitPerDay ?? '',
      limitPerYear: companyData?.limitPerYear ?? '',
      companyLogoUrl,
    });
  };

  const handleDeleteCompany = async (companyData) => {
    if (!canManageCompany || !companyData?._id) {
      toast({
        title: 'You do not have permission to delete this community',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const result = await Swal.fire({
      title: 'Delete community?',
      text: "This community will no longer be available in the dashboard.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel',
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);
      await axiosInstance.put(
        `${baseUrl}/company/delete/${companyData._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        },
      );
      clearCompanyStorage();
      setSelectedCompany(null);
      await getCompany();
      Swal.fire('Deleted!', 'Community has been deleted.', 'success');
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Failed to delete community');
    }
  };

  const DetailItem = ({ label, value }) => (
    <Box minW={0}>
      <Text fontSize="xs" fontWeight="700" color={labelColor} mb={1}>
        {label}
      </Text>
      <Text fontSize="sm" fontWeight="600" color={textColor} wordBreak="break-word">
        {getValue(value)}
      </Text>
    </Box>
  );

  const CompanySection = ({ title, children, onEdit }) => (
    <Card
      bg={modalBg}
      border="1px solid"
      borderColor={profileBorderColor}
      borderRadius="8px"
      boxShadow="sm"
      p={5}
    >
      <Flex align="center" justify="space-between" mb={4}>
        <Text color="blue.600" fontSize="sm" fontWeight="800">
          {title}
        </Text>
        {canManageCompany && onEdit && (
          <Button
            size="xs"
            variant="outline"
            leftIcon={<EditIcon />}
            borderRadius="md"
            onClick={onEdit}
          >
            Edit
          </Button>
        )}
      </Flex>
      {children}
    </Card>
  );

  return (
    <Box
      pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
      px={{ base: '4', md: '8' }}
    >
      <Flex
        mb="4"
        justifyContent="space-between"
        alignItems="center"
        gap={4}
        flexWrap="wrap"
      >
        <Text fontSize="xl" fontWeight="800" color={textColor}>
          Community Profile
        </Text>
        <HStack spacing={3} flexWrap="wrap">
          {userRole === 'admin' && company.length > 1 && (
            <Select
              value={profileCompany?._id || ''}
              onChange={(event) => {
                const nextCompany = company.find(
                  (item) => item._id === event.target.value,
                );
                setSelectedCompany(nextCompany || company?.[0] || null);
              }}
              bg={modalBg}
              borderColor={profileBorderColor}
              borderRadius="8px"
              maxW={{ base: '100%', md: '320px' }}
            >
              {company.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Select>
          )}
          {canManageCompany && profileCompany && (
            <Button
              colorScheme="red"
              variant="outline"
              leftIcon={<DeleteIcon />}
              onClick={() => handleDeleteCompany(profileCompany)}
            >
              Delete Community
            </Button>
          )}
        </HStack>
      </Flex>

      {loading ? (
        <Flex minH="360px" align="center" justify="center">
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : !profileCompany ? (
        <Card
          bg={modalBg}
          border="1px solid"
          borderColor={profileBorderColor}
          borderRadius="8px"
          p={8}
          textAlign="center"
        >
          <Text fontSize="lg" fontWeight="700" color={textColor}>
            No community found
          </Text>
          {canManageCompany ? (
            <Button
              mt={5}
              colorScheme="blue"
              onClick={onOpen}
              leftIcon={<AddIcon />}
            >
              Add Community
            </Button>
          ) : (
            <Text mt={3} color={labelColor}>
              You have view-only access.
            </Text>
          )}
        </Card>
      ) : (
        <Flex align="stretch" gap={6} direction={{ base: 'column', xl: 'row' }}>
          <Box flex="1" minW={0}>
            <Card
              bg={modalBg}
              border="1px solid"
              borderColor={profileBorderColor}
              borderRadius="8px"
              boxShadow="sm"
              p={{ base: 4, md: 5 }}
              mb={4}
            >
              <Flex
                align={{ base: 'flex-start', md: 'center' }}
                gap={5}
                direction={{ base: 'column', md: 'row' }}
              >
                <Box position="relative" flexShrink={0}>
                  <Flex
                    w="108px"
                    h="108px"
                    borderRadius="full"
                    align="center"
                    justify="center"
                    border="2px solid"
                    borderColor="blue.200"
                    overflow="hidden"
                    bg={logoCircleBg}
                  >
                    {getCompanyLogoUrl(profileCompany) ? (
                      <Image
                        src={getCompanyLogoUrl(profileCompany)}
                        alt={`${profileCompany?.name || 'Community'} logo`}
                        maxW="92px"
                        maxH="92px"
                        objectFit="contain"
                      />
                    ) : (
                      <Icon as={FaBuilding} w={9} h={9} color="blue.500" />
                    )}
                  </Flex>
                  {canManageCompany && (
                    <Flex
                      position="absolute"
                      right="4px"
                      bottom="8px"
                      w="28px"
                      h="28px"
                      bg="rgba(0, 106, 184, 1)"
                      color="white"
                      borderRadius="full"
                      align="center"
                      justify="center"
                      border="2px solid"
                      borderColor={modalBg}
                    >
                      <Icon as={EditIcon} w={3} h={3} />
                    </Flex>
                  )}
                </Box>

                <Box flex="1" minW={0}>
                  <Text fontSize="lg" fontWeight="800" color={textColor} mb={4}>
                    {profileCompany?.name}
                  </Text>
                  <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
                    <DetailItem
                      label="Device PID"
                      value={
                        profileCompany?.companyId ||
                        profileCompany?.devices?.[0]?.productId
                      }
                    />
                    <DetailItem label="Device Password" value="********" />
                    <DetailItem label="License Key" value="********" />
                  </SimpleGrid>
                </Box>
              </Flex>
            </Card>

            <CompanySection
              title="Community Details"
              onEdit={() => handleEdit(profileCompany)}
            >
              <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={12} spacingY={4}>
                <DetailItem label="Community Name" value={profileCompany?.name} />
                <DetailItem
                  label="Community Contact Person"
                  value={profileCompany?.companyRepresentativeName}
                />
                <DetailItem label="Email" value={profileCompany?.email1} />
                <DetailItem label="Mobile Number" value={profileCompany?.contact1} />
                <DetailItem
                  label="Country"
                  value={profileCompany?.address?.country}
                />
                <DetailItem label="State" value={profileCompany?.address?.state} />
                <DetailItem label="City" value={profileCompany?.address?.city} />
                <DetailItem label="Zip / PIN" value={profileCompany?.address?.zipcode} />
                <DetailItem
                  label="Registered Address"
                  value={formatAddress(profileCompany?.address)}
                />
              </SimpleGrid>
            </CompanySection>

            <Box mt={4}>
              <CompanySection
                title="NOC Compliance Details"
                onEdit={() => handleEdit(profileCompany)}
              >
                <SimpleGrid columns={{ base: 1, md: 2 }} spacingX={12} spacingY={4}>
                  <DetailItem
                    label="NOC No"
                    value={profileCompany?.nocDetails?.nocNumber}
                  />
                  <DetailItem
                    label="Valid From"
                    value={formatDate(
                      profileCompany?.nocDetails?.nocExpiry?.startDate,
                    )}
                  />
                  <DetailItem
                    label="Valid Till"
                    value={formatDate(profileCompany?.nocDetails?.nocExpiry?.endDate)}
                  />
                  <DetailItem
                    label="Daily Limit(m3)"
                    value={profileCompany?.limitPerDay}
                  />
                  <DetailItem
                    label="Yearly Limit(m3)"
                    value={profileCompany?.limitPerYear}
                  />
                  <DetailItem
                    label="No of Borewell(s)"
                    value={profileCompany?.devices?.length || 0}
                  />
                </SimpleGrid>
              </CompanySection>
            </Box>
          </Box>

          <Card
            w={{ base: '100%', xl: '340px' }}
            bg={modalBg}
            border="1px solid"
            borderColor={profileBorderColor}
            borderRadius="8px"
            boxShadow="sm"
            p={5}
            alignSelf="stretch"
          >
            <Text color="blue.600" fontSize="sm" fontWeight="800" mb={4}>
              Documents
            </Text>
            {profileCompany?.nocDocument?.originalName ? (
              <Flex
                align="center"
                justify="space-between"
                gap={3}
                py={3}
                borderBottom="1px solid"
                borderColor={documentBorderColor}
              >
                <Flex align="center" gap={3} minW={0}>
                  <Flex
                    w="30px"
                    h="30px"
                    borderRadius="md"
                    align="center"
                    justify="center"
                    bg={documentIconBg}
                    flexShrink={0}
                  >
                    <Icon as={FaFilePdf} color="blue.600" />
                  </Flex>
                  <Text
                    color={textColor}
                    fontSize="sm"
                    fontWeight="600"
                    noOfLines={1}
                    title={profileCompany.nocDocument.originalName}
                  >
                    {profileCompany.nocDocument.originalName}
                  </Text>
                </Flex>
                <HStack spacing={1}>
                  <Tooltip label="Download">
                    <Button
                      size="sm"
                      variant="ghost"
                      colorScheme="blue"
                      isLoading={downloadingDocId === profileCompany._id}
                      onClick={() => handleDownloadNocDocument(profileCompany)}
                    >
                      <Icon as={ArrowUpIcon} transform="rotate(180deg)" />
                    </Button>
                  </Tooltip>
                  {canManageCompany && (
                    <Tooltip label="Replace from edit form">
                      <Button
                        size="sm"
                        variant="ghost"
                        colorScheme="red"
                        onClick={() => handleEdit(profileCompany)}
                      >
                        <DeleteIcon />
                      </Button>
                    </Tooltip>
                  )}
                </HStack>
              </Flex>
            ) : (
              <Text color={labelColor} fontSize="sm">
                No documents uploaded
              </Text>
            )}
          </Card>
        </Flex>
      )}

      <Modal isOpen={isOpen} onClose={handleAddModalClose} size="lg">
        <ModalOverlay />
        <ModalContent maxWidth="900px" bg={modalBg} rounded="xl" boxShadow="lg">
          <Box
            bg={addmodalheaderBg}
            py={1}
            px={2}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={AddIcon} mr={2} />
              Add New Community
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>

          <ModalBody p={6}>
            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaInfoCircle} w={6} h={6} color="blue.500" mr={2} />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Basic Details
                </Text>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                <FormControl isRequired isInvalid={addErrors.name}>
                  <FormLabel fontSize="sm">Community Name</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBuilding} />
                    </InputLeftElement>
                    <Input
                      name="name"
                      placeholder="Enter community name"
                      value={addCompany?.name}
                      onChange={handleAddChange}
                      borderRadius="md"
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('gray.800', 'white')}
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{addErrors.name}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Community Logo</FormLabel>
                  <Input
                    id="add-company-logo"
                    type="file"
                    name="companyLogo"
                    accept="image/png,image/jpeg,.png,.jpg,.jpeg"
                    onChange={handleAddLogoFileChange}
                    display="none"
                  />
                  <Button
                    as="label"
                    htmlFor="add-company-logo"
                    leftIcon={<Icon as={MdUploadFile} />}
                    width="100%"
                    justifyContent="flex-start"
                    variant="outline"
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.700', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    fontWeight="medium"
                    cursor="pointer"
                    _hover={{
                      bg: useColorModeValue('blue.50', 'whiteAlpha.100'),
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    Upload Community Logo
                  </Button>
                  {addLogoFile && (
                    <Flex
                      mt={2}
                      align="center"
                      gap={2}
                      px={3}
                      py={2}
                      borderRadius="md"
                      bg={nocFileChipBg}
                      border="1px solid"
                      borderColor={nocFileChipBorder}
                    >
                      <Icon as={MdUploadFile} color="blue.500" />
                      <Text fontSize="xs" color={textColor} noOfLines={1}>
                        {addLogoFile.name}
                      </Text>
                    </Flex>
                  )}
                </FormControl>
              </SimpleGrid>
            </Box>

            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaAddressBook} w={6} h={6} color="green.500" mr={2} />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Contact Information
                </Text>
              </Flex>

              <Accordion allowToggle>
                <AccordionItem border="none">
                  <h2>
                    <AccordionButton
                      _expanded={{
                        bg: useColorModeValue('gray.200', 'gray.700'),
                      }}
                      borderRadius="md"
                      bg={useColorModeValue('gray.100', 'gray.600')}
                    >
                      <Flex
                        flex="1"
                        alignContent={'center'}
                        textAlign="left"
                        fontWeight="semibold"
                      >
                        <Icon
                          as={FaEnvelope}
                          w={4}
                          h={4}
                          color="orange.500"
                          mr={2}
                          mt={1}
                        />
                        <Text fontSize="md" fontWeight="semibold">
                          Email
                        </Text>
                      </Flex>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                      <FormControl isRequired isInvalid={addErrors.email1}>
                        <FormLabel fontSize="sm">Primary Email</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={EmailIcon} />
                          </InputLeftElement>
                          <Input
                            name="email1"
                            type="email"
                            placeholder="Enter primary email address"
                            value={addCompany?.email1}
                            onChange={handleAddChange}
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('black', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>{addErrors.email1}</FormErrorMessage>
                      </FormControl>

                      {/* Secondary Email */}
                      <FormControl>
                        <FormLabel fontSize="sm">Secondary Email</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={EmailIcon} />
                          </InputLeftElement>
                          <Input
                            name="email2"
                            type="email"
                            placeholder="Enter secondary email address"
                            value={addCompany?.email2}
                            onChange={handleAddChange}
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('black', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                      </FormControl>
                    </SimpleGrid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion allowToggle mt={2}>
                <AccordionItem border="none">
                  <h2>
                    <AccordionButton
                      _expanded={{
                        bg: useColorModeValue('gray.200', 'gray.700'),
                      }}
                      borderRadius="md"
                      bg={useColorModeValue('gray.100', 'gray.600')}
                    >
                      <Flex
                        flex="1"
                        alignContent={'center'}
                        textAlign="left"
                        fontWeight="semibold"
                      >
                        <Icon
                          as={FaPhoneAlt}
                          w={4}
                          h={4}
                          color="blue.500"
                          mr={2}
                          mt={1}
                        />
                        <Text fontSize="md" fontWeight="600">
                          Contact
                        </Text>
                      </Flex>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                      <FormControl isRequired isInvalid={addErrors.contact1}>
                        <FormLabel fontSize="sm">Primary Contact</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaPhoneAlt} />
                          </InputLeftElement>
                          <Input
                            name="contact1"
                            placeholder="Enter primary contact"
                            value={addCompany?.contact1}
                            onChange={handleAddChange}
                            type="tel"
                            inputMode="numeric"
                            maxLength={INDIAN_MOBILE_DIGITS}
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('black', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>
                          {addErrors.contact1}
                        </FormErrorMessage>
                      </FormControl>

                      <FormControl isInvalid={addErrors.contact2}>
                        <FormLabel fontSize="sm">Secondary Contact</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaPhoneAlt} />
                          </InputLeftElement>
                          <Input
                            name="contact2"
                            placeholder="Enter secondary contact"
                            value={addCompany?.contact2}
                            onChange={handleAddChange}
                            type="tel"
                            inputMode="numeric"
                            maxLength={INDIAN_MOBILE_DIGITS}
                            bg={useColorModeValue('white', 'gray.700')}
                            color={useColorModeValue('black', 'white')}
                            borderRadius="md"
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>
                          {addErrors.contact2}
                        </FormErrorMessage>
                      </FormControl>
                    </SimpleGrid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Box>

            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon
                  as={FaMapMarkedAlt}
                  w={6}
                  h={6}
                  color="orange.500"
                  mr={2}
                />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Address Information
                </Text>
              </Flex>
              <FormControl isRequired isInvalid={addErrors.address}>
                <FormLabel fontSize="sm">Address Line</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" color="gray.400">
                    <Icon as={FaMapMarkerAlt} />
                  </InputLeftElement>
                  <Textarea
                    name="addressLine"
                    placeholder="Enter address"
                    value={addCompany?.addressLine}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    pl="10"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                </InputGroup>
                <FormErrorMessage>{addErrors.address}</FormErrorMessage>
              </FormControl>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6" mt={6}>
                <FormControl>
                  <FormLabel fontSize="sm">City</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCity} />
                    </InputLeftElement>
                    <Input
                      name="city"
                      placeholder="Enter city"
                      value={addCompany?.city}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('black', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">State</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaFlag} />
                    </InputLeftElement>
                    <Input
                      name="state"
                      placeholder="Enter state"
                      value={addCompany?.state}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('black', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Country</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaGlobe} />
                    </InputLeftElement>
                    <Input
                      name="country"
                      placeholder="Enter country"
                      value={addCompany?.country}
                      onChange={handleAddChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('black', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired isInvalid={addErrors.zipcode}>
                  <FormLabel fontSize="sm">Zipcode</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaHashtag} />
                    </InputLeftElement>
                    <Input
                      name="zipcode"
                      placeholder="Enter zipcode"
                      value={addCompany?.zipcode}
                      onChange={handleAddChange}
                      type="tel"
                      inputMode="numeric"
                      maxLength={INDIAN_PIN_DIGITS}
                      bg={useColorModeValue('white', 'gray.700')}
                      color={useColorModeValue('black', 'white')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{addErrors.zipcode}</FormErrorMessage>
                </FormControl>
              </SimpleGrid>
            </Box>

            <Box>
              <Flex alignItems="center" mb={4}>
                <Icon
                  as={FaClipboardList}
                  w={6}
                  h={6}
                  color="purple.500"
                  mr={2}
                />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  NOC Compliance Details
                </Text>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                <FormControl isRequired isInvalid={addErrors.nocNumber}>
                  <FormLabel fontSize="sm">NOC Number</FormLabel>
                  <Input
                    name="nocNumber"
                    placeholder="Enter NOC Number"
                    value={addCompany?.nocDetails.nocNumber}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{addErrors.nocNumber}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">NOC PDF</FormLabel>
                  <Input
                    id="add-noc-pdf"
                    type="file"
                    name="nocPdf"
                    accept="application/pdf,.pdf"
                    onChange={handleAddNocFileChange}
                    display="none"
                  />
                  <Button
                    as="label"
                    htmlFor="add-noc-pdf"
                    leftIcon={<Icon as={MdUploadFile} />}
                    width="100%"
                    justifyContent="flex-start"
                    variant="outline"
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.700', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    fontWeight="medium"
                    cursor="pointer"
                    _hover={{
                      bg: useColorModeValue('blue.50', 'whiteAlpha.100'),
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    Upload NOC PDF
                  </Button>
                  {addNocFile && (
                    <Flex
                      mt={2}
                      align="center"
                      gap={2}
                      px={3}
                      py={2}
                      borderRadius="md"
                      bg={nocFileChipBg}
                      border="1px solid"
                      borderColor={nocFileChipBorder}
                    >
                      <Icon as={FaFilePdf} color="red.500" />
                      <Text fontSize="xs" color={textColor} noOfLines={1}>
                        {addNocFile.name}
                      </Text>
                    </Flex>
                  )}
                </FormControl>

                <FormControl isRequired isInvalid={addErrors.nocStartDate}>
                  <FormLabel fontSize="sm">Valid From</FormLabel>
                  <Input
                    type="date"
                    name="startDate"
                    placeholder="Enter NOC Start Date"
                    value={addCompany?.nocDetails.nocExpiry.startDate}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{addErrors.nocStartDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={addErrors.nocEndDate}>
                  <FormLabel fontSize="sm">Valid Till</FormLabel>
                  <Input
                    type="date"
                    name="endDate"
                    placeholder="Enter NOC End Date"
                    value={addCompany?.nocDetails.nocExpiry.endDate}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{addErrors.nocEndDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={addErrors.dailyLimit}>
                  <FormLabel fontSize="sm">Daily Limit</FormLabel>
                  <Input
                    name="limitPerDay"
                    placeholder="Enter daily limit"
                    value={addCompany?.limitPerDay}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{addErrors.dailyLimit}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={addErrors.yearlyLimit}>
                  <FormLabel fontSize="sm">Yearly Limit</FormLabel>
                  <Input
                    name="limitPerYear"
                    placeholder="Enter yearly limit"
                    value={addCompany?.limitPerYear}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{addErrors.yearlyLimit}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Community Contact Person</FormLabel>
                  <Input
                    name="companyRepresentativeName"
                    placeholder="Enter contact person name"
                    value={addCompany?.companyRepresentativeName}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                </FormControl>

                {/* <FormControl>
                  <FormLabel fontSize="sm">Aquasense Sales Executive</FormLabel>
                  <Select
                    name="aquasenseSalesRepresentative"
                    placeholder="Select Sales Executive"
                    value={addCompany?.aquasenseSalesRepresentative}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  >
                    {users
                      ?.filter((user) => user?.role === 'sales')
                      .map((filteredUser) => (
                        <option
                          key={filteredUser?._id}
                          value={filteredUser?._id}
                        >
                          {filteredUser?.name}
                        </option>
                      ))}
                  </Select>
                </FormControl> */}

                {/* <FormControl>
                  <FormLabel fontSize="sm">Aquasense IRM Executive</FormLabel>
                  <Select
                    name="aquasenseIRMUser"
                    placeholder="Select IRM Executive"
                    value={addCompany?.aquasenseIRMUser}
                    onChange={handleAddChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  >
                    {users
                      ?.filter((user) => user?.role === 'IRM')
                      .map((filteredUser) => (
                        <option
                          key={filteredUser?._id}
                          value={filteredUser?._id}
                        >
                          {filteredUser?.name}
                        </option>
                      ))}
                  </Select>
                </FormControl> */}
              </SimpleGrid>
            </Box>
          </ModalBody>

          <ModalFooter
            bg={useColorModeValue('gray.50', 'gray.800')}
            borderTop="1px solid"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            py={5}
            px={6}
            justifyContent="space-between"
            roundedBottom="xl"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              onClick={handleAddModalClose}
              borderRadius="md"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
            >
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleAddCompany}
              isLoading={loading}
              borderRadius="md"
              shadow="sm"
              _hover={{ shadow: 'md', transform: 'translateY(-1px)' }}
            >
              Add Community
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEditOpen} onClose={handleEditModalClose} size="lg">
        <ModalOverlay />
        <ModalContent
          maxWidth="900px"
          mx="auto"
          bg={modalBg}
          rounded="xl"
          boxShadow="lg"
          overflow="hidden"
        >
          <Box
            bg={addmodalheaderBg}
            py={1}
            px={2}
            textAlign="center"
            roundedTop="xl"
          >
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={EditIcon} mr={2} />
              Edit Community
            </ModalHeader>
            <ModalCloseButton />
          </Box>

          <ModalBody p={6}>
            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaInfoCircle} w={6} h={6} color="blue.500" mr={2} />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Basic Details
                </Text>
              </Flex>{' '}
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                <FormControl isRequired isInvalid={editErrors.name}>
                  <FormLabel fontSize="sm">Community Name</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaBuilding} />
                    </InputLeftElement>
                    <Input
                      name="name"
                      placeholder="Enter community name"
                      value={editCompany?.name}
                      onChange={handleEditChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      borderRadius="md"
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{editErrors.name}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Community Logo</FormLabel>
                  <Input
                    id="edit-company-logo"
                    type="file"
                    name="companyLogo"
                    accept="image/png,image/jpeg,.png,.jpg,.jpeg"
                    onChange={handleEditLogoFileChange}
                    display="none"
                  />
                  <Button
                    as="label"
                    htmlFor="edit-company-logo"
                    leftIcon={<Icon as={MdUploadFile} />}
                    width="100%"
                    justifyContent="flex-start"
                    variant="outline"
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.700', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    fontWeight="medium"
                    cursor="pointer"
                    _hover={{
                      bg: useColorModeValue('blue.50', 'whiteAlpha.100'),
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    {editCompany?.companyLogo?.originalName
                      ? 'Replace Community Logo'
                      : 'Upload Community Logo'}
                  </Button>
                  {(editLogoFile || editCompany?.companyLogo?.originalName) && (
                    <Flex
                      mt={2}
                      align="center"
                      gap={2}
                      px={3}
                      py={2}
                      borderRadius="md"
                      bg={nocFileChipBg}
                      border="1px solid"
                      borderColor={nocFileChipBorder}
                    >
                      <Icon as={MdUploadFile} color="blue.500" />
                      <Text fontSize="xs" color={textColor} noOfLines={1}>
                        {editLogoFile?.name ||
                          editCompany?.companyLogo?.originalName}
                      </Text>
                    </Flex>
                  )}
                </FormControl>
              </SimpleGrid>
            </Box>

            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon as={FaAddressBook} w={6} h={6} color="green.500" mr={2} />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Contact Information
                </Text>
              </Flex>

              <Accordion allowToggle defaultIndex={[0]}>
                <AccordionItem border="none">
                  <h2>
                    <AccordionButton
                      _expanded={{
                        bg: useColorModeValue('gray.200', 'gray.700'),
                      }}
                      borderRadius="md"
                      bg={useColorModeValue('gray.100', 'gray.600')}
                    >
                      <Flex
                        flex="1"
                        alignContent={'center'}
                        textAlign="left"
                        fontWeight="semibold"
                      >
                        <Icon
                          as={FaEnvelope}
                          w={4}
                          h={4}
                          color="orange.500"
                          mr={2}
                          mt={1}
                        />
                        <Text fontSize="md" fontWeight="semibold">
                          Email
                        </Text>
                      </Flex>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                      <FormControl isRequired isInvalid={editErrors.email1}>
                        <FormLabel fontSize="sm">Primary Email</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={EmailIcon} />
                          </InputLeftElement>
                          <Input
                            name="email1"
                            type="email"
                            placeholder="Enter primary email address"
                            value={editCompany?.email1}
                            onChange={handleEditChange}
                            bg={useColorModeValue('white', 'gray.700')}
                            borderRadius="md"
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>{editErrors.email1}</FormErrorMessage>
                      </FormControl>
                      <FormControl>
                        <FormLabel fontSize="sm">Secondary Email</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={EmailIcon} />
                          </InputLeftElement>
                          <Input
                            name="email2"
                            type="email"
                            placeholder="Enter secondary email address"
                            value={editCompany?.email2}
                            onChange={handleEditChange}
                            bg={useColorModeValue('white', 'gray.700')}
                            borderRadius="md"
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                          />
                        </InputGroup>
                      </FormControl>
                    </SimpleGrid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Accordion allowToggle mt={2} defaultIndex={[0]}>
                <AccordionItem border="none">
                  <h2>
                    <AccordionButton
                      _expanded={{
                        bg: useColorModeValue('gray.200', 'gray.700'),
                      }}
                      borderRadius="md"
                      bg={useColorModeValue('gray.100', 'gray.600')}
                    >
                      <Flex
                        flex="1"
                        alignContent={'center'}
                        textAlign="left"
                        fontWeight="semibold"
                      >
                        <Icon
                          as={FaPhoneAlt}
                          w={4}
                          h={4}
                          color="blue.500"
                          mr={2}
                          mt={1}
                        />
                        <Text fontSize="md" fontWeight="600">
                          Contact
                        </Text>
                      </Flex>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                      <FormControl isRequired isInvalid={editErrors.contact1}>
                        <FormLabel fontSize="sm">Primary Contact</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaPhoneAlt} />
                          </InputLeftElement>
                          <Input
                            name="contact1"
                            placeholder="Enter primary contact"
                            value={editCompany?.contact1}
                            onChange={handleEditChange}
                            type="tel"
                            inputMode="numeric"
                            maxLength={INDIAN_MOBILE_DIGITS}
                            bg={useColorModeValue('white', 'gray.700')}
                            borderRadius="md"
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>
                          {editErrors.contact1}
                        </FormErrorMessage>
                      </FormControl>
                      <FormControl isInvalid={editErrors.contact2}>
                        <FormLabel fontSize="sm">Secondary Contact</FormLabel>
                        <InputGroup>
                          <InputLeftElement
                            pointerEvents="none"
                            color="gray.400"
                          >
                            <Icon as={FaPhoneAlt} />
                          </InputLeftElement>
                          <Input
                            name="contact2"
                            placeholder="Enter secondary contact"
                            value={editCompany?.contact2}
                            onChange={handleEditChange}
                            type="tel"
                            inputMode="numeric"
                            maxLength={INDIAN_MOBILE_DIGITS}
                            bg={useColorModeValue('white', 'gray.700')}
                            borderRadius="md"
                            _placeholder={{
                              color: useColorModeValue('gray.500', 'gray.400'),
                            }}
                            borderWidth="2px"
                            borderColor={useColorModeValue(
                              'gray.300',
                              'gray.600',
                            )}
                            _hover={{
                              borderColor: useColorModeValue(
                                'blue.400',
                                'blue.600',
                              ),
                            }}
                            _focus={{
                              borderColor: useColorModeValue(
                                'blue.500',
                                'blue.300',
                              ),
                              boxShadow: 'outline',
                            }}
                          />
                        </InputGroup>
                        <FormErrorMessage>
                          {editErrors.contact2}
                        </FormErrorMessage>
                      </FormControl>
                    </SimpleGrid>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </Box>

            <Box mb={8}>
              <Flex alignItems="center" mb={4}>
                <Icon
                  as={FaMapMarkedAlt}
                  w={6}
                  h={6}
                  color="orange.500"
                  mr={2}
                />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  Address Information
                </Text>
              </Flex>

              <FormControl isRequired isInvalid={editErrors.address}>
                <FormLabel fontSize="sm">Address Line</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none" color="gray.400">
                    <Icon as={FaMapMarkerAlt} w={5} h={5} />{' '}
                  </InputLeftElement>
                  <Textarea
                    name="addressLine"
                    placeholder="Enter address"
                    value={editCompany?.addressLine}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    resize="vertical"
                    borderRadius="md"
                    pl="12"
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  />
                </InputGroup>
                <FormErrorMessage>{editErrors.address}</FormErrorMessage>
              </FormControl>

              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4" mt={4}>
                <FormControl>
                  <FormLabel fontSize="sm">City</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaCity} w={5} h={5} />
                    </InputLeftElement>
                    <Input
                      name="city"
                      placeholder="Enter city"
                      value={editCompany?.city}
                      onChange={handleEditChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      borderRadius="md"
                      pl="12"
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">State</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaFlag} w={5} h={5} />
                    </InputLeftElement>
                    <Input
                      name="state"
                      placeholder="Enter state"
                      value={editCompany?.state}
                      onChange={handleEditChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      borderRadius="md"
                      pl="12"
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Country</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaGlobe} w={5} h={5} />
                    </InputLeftElement>
                    <Input
                      name="country"
                      placeholder="Enter country"
                      value={editCompany?.country}
                      onChange={handleEditChange}
                      bg={useColorModeValue('white', 'gray.700')}
                      borderRadius="md"
                      pl="12"
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                    />
                  </InputGroup>
                </FormControl>

                <FormControl isRequired isInvalid={editErrors.zipcode}>
                  <FormLabel fontSize="sm">Zipcode</FormLabel>
                  <InputGroup>
                    <InputLeftElement pointerEvents="none" color="gray.400">
                      <Icon as={FaHashtag} w={5} h={5} />
                    </InputLeftElement>
                    <Input
                      name="zipcode"
                      placeholder="Enter zipcode"
                      value={editCompany?.zipcode}
                      onChange={handleEditChange}
                      type="tel"
                      inputMode="numeric"
                      maxLength={INDIAN_PIN_DIGITS}
                      bg={useColorModeValue('white', 'gray.700')}
                      borderRadius="md"
                      pl="12"
                      _placeholder={{
                        color: useColorModeValue('gray.500', 'gray.400'),
                      }}
                      borderWidth="2px"
                      borderColor={useColorModeValue('gray.300', 'gray.600')}
                      _hover={{
                        borderColor: useColorModeValue('blue.400', 'blue.600'),
                      }}
                      _focus={{
                        borderColor: useColorModeValue('blue.500', 'blue.300'),
                        boxShadow: 'outline',
                      }}
                    />
                  </InputGroup>
                  <FormErrorMessage>{editErrors.zipcode}</FormErrorMessage>
                </FormControl>
              </SimpleGrid>
            </Box>

            <Box>
              <Flex alignItems="center" mb={4}>
                <Icon
                  as={FaClipboardList}
                  w={6}
                  h={6}
                  color="purple.500"
                  mr={2}
                />{' '}
                <Text fontSize="lg" fontWeight="semibold">
                  NOC Compliance Details
                </Text>
              </Flex>

              <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                <FormControl isRequired isInvalid={editErrors.nocNumber}>
                  <FormLabel fontSize="sm">Noc Number</FormLabel>
                  <Input
                    name="nocNumber"
                    placeholder="Enter NOC Nuber"
                    value={editCompany?.nocDetails?.nocNumber}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{editErrors.nocNumber}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">NOC PDF</FormLabel>
                  <Input
                    id="edit-noc-pdf"
                    type="file"
                    name="nocPdf"
                    accept="application/pdf,.pdf"
                    onChange={handleEditNocFileChange}
                    display="none"
                  />
                  <Button
                    as="label"
                    htmlFor="edit-noc-pdf"
                    leftIcon={<Icon as={MdUploadFile} />}
                    width="100%"
                    justifyContent="flex-start"
                    variant="outline"
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('gray.700', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    fontWeight="medium"
                    cursor="pointer"
                    _hover={{
                      bg: useColorModeValue('blue.50', 'whiteAlpha.100'),
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    {editCompany?.nocDocument?.originalName
                      ? 'Replace NOC PDF'
                      : 'Upload NOC PDF'}
                  </Button>
                  {(editNocFile || editCompany?.nocDocument?.originalName) && (
                    <Flex
                      mt={2}
                      align="center"
                      gap={2}
                      px={3}
                      py={2}
                      borderRadius="md"
                      bg={nocFileChipBg}
                      border="1px solid"
                      borderColor={nocFileChipBorder}
                    >
                      <Icon as={FaFilePdf} color="red.500" />
                      <Text fontSize="xs" color={textColor} noOfLines={1}>
                        {editNocFile?.name ||
                          editCompany?.nocDocument?.originalName}
                      </Text>
                    </Flex>
                  )}
                </FormControl>

                <FormControl isRequired isInvalid={editErrors.nocStartDate}>
                  <FormLabel fontSize="sm">Valid From</FormLabel>
                  <Input
                    type="date"
                    name="startDate"
                    // placeholder="Enter daily limit"
                    value={
                      editCompany?.nocDetails?.nocExpiry?.startDate?.split(
                        'T',
                      )[0] || ''
                    }
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{editErrors.nocStartDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={editErrors.nocEndDate}>
                  <FormLabel fontSize="sm">Valid Till</FormLabel>
                  <Input
                    type="date"
                    name="endDate"
                    // placeholder="Enter daily limit"
                    value={
                      editCompany?.nocDetails?.nocExpiry?.endDate?.split(
                        'T',
                      )[0] || ''
                    }
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{editErrors.nocEndDate}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={editErrors.dailyLimit}>
                  <FormLabel fontSize="sm">Daily Limit</FormLabel>
                  <Input
                    name="limitPerDay"
                    placeholder="Enter daily limit"
                    value={editCompany?.limitPerDay}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{editErrors.dailyLimit}</FormErrorMessage>
                </FormControl>

                <FormControl isRequired isInvalid={editErrors.yearlyLimit}>
                  <FormLabel fontSize="sm">Yearly Limit</FormLabel>
                  <Input
                    name="limitPerYear"
                    placeholder="Enter yearly limit"
                    value={editCompany?.limitPerYear}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    color={useColorModeValue('black', 'white')}
                    borderRadius="md"
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                  />
                  <FormErrorMessage>{editErrors.yearlyLimit}</FormErrorMessage>
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="sm">Community Contact Person</FormLabel>
                  <Input
                    name="companyRepresentativeName"
                    placeholder="Enter contact person name"
                    value={editCompany?.companyRepresentativeName}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    borderRadius="md"
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  />
                </FormControl>
                {/* <FormControl>
                  <FormLabel fontSize="sm">Aquasense Sales Executive</FormLabel>
                  <Select
                    name="aquasenseSalesRepresentative"
                    placeholder="Select Sales Executive"
                    value={editCompany?.aquasenseSalesRepresentative}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    borderRadius="md"
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    {users
                      ?.filter((user) => user?.role === 'sales')
                      .map((filteredUser) => (
                        <option
                          key={filteredUser?._id}
                          value={filteredUser?._id}
                        >
                          {filteredUser?.name}
                        </option>
                      ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize="sm">Aquasense IRM Executive</FormLabel>
                  <Select
                    name="aquasenseIRMUser"
                    placeholder="Select IRM Executive"
                    value={editCompany?.aquasenseIRMUser}
                    onChange={handleEditChange}
                    bg={useColorModeValue('white', 'gray.700')}
                    borderRadius="md"
                    _placeholder={{
                      color: useColorModeValue('gray.500', 'gray.400'),
                    }}
                    borderWidth="2px"
                    borderColor={useColorModeValue('gray.300', 'gray.600')}
                    _hover={{
                      borderColor: useColorModeValue('blue.400', 'blue.600'),
                    }}
                    _focus={{
                      borderColor: useColorModeValue('blue.500', 'blue.300'),
                      boxShadow: 'outline',
                    }}
                  >
                    {users
                      ?.filter((user) => user?.role === 'IRM')
                      .map((filteredUser) => (
                        <option
                          key={filteredUser?._id}
                          value={filteredUser?._id}
                        >
                          {filteredUser?.name}
                        </option>
                      ))}
                  </Select>
                </FormControl> */}
              </SimpleGrid>
            </Box>
          </ModalBody>

          <ModalFooter
            bg={useColorModeValue('gray.50', 'gray.800')}
            borderTop="1px solid"
            borderColor={useColorModeValue('gray.200', 'gray.700')}
            py={4}
            justifyContent="space-between"
          >
            <Button
              variant="ghost"
              colorScheme="red"
              fontWeight="medium"
              _hover={{ bg: useColorModeValue('red.50', 'red.900') }}
              onClick={handleEditModalClose}
              borderRadius="md"
            >
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSave}
              isLoading={loading}
              borderRadius="md"
              shadow="md"
              _hover={{ transform: 'translateY(-1px)', shadow: 'lg' }}
            >
              Save Changes
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isViewOpen} onClose={onViewClose} size="lg">
        <ModalOverlay />
        <ModalContent maxWidth="900px" mx="auto" rounded="lg" shadow="lg">
          <Box
            bg={addmodalheaderBg}
            color="white"
            py={1}
            textAlign="center"
            roundedTop="lg"
          >
            <ModalHeader fontSize="2xl" fontWeight="bold">
              <Icon as={InfoOutlineIcon} mr={2} />
              COMMUNITY DETAILS
            </ModalHeader>
            <ModalCloseButton />
          </Box>

          <ModalBody>
            {selectedCompany && (
              <Box p={4}>
                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color="purple.500"
                  >
                    <Icon as={InfoIcon} mr={2} />
                    Basic Information
                  </Text>
                  <Box bg={sectionBg} p={4} rounded="md" shadow="md">
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={AtSignIcon} mr={1} />
                          Community Name:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.name || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={EmailIcon} mr={1} />
                          Primary Email:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.email1 || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={EmailIcon} mr={1} />
                          Secondary Email:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.email2 || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={PhoneIcon} mr={1} />
                          Primary Contact:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.contact1 || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={PhoneIcon} mr={1} />
                          Secondary Contact:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.contact2 || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={CheckCircleIcon} mr={1} />
                          Representative Name:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.companyRepresentativeName || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={FaUser} mr={1} />
                          Community Admin:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.companyAdmin?.name || 'N/A'}
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Box>
                </Box>
                <Divider my={6} />
                <Box mb={6}>
                  <Text
                    fontSize="lg"
                    fontWeight="bold"
                    mb={4}
                    color="green.500"
                  >
                    <Icon as={FaMapMarkerAlt} mr={2} />
                    Address Information
                  </Text>
                  <Box bg={sectionBg} p={4} rounded="md" shadow="md">
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={FaHome} mr={1} />
                          Address Line:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.address?.addressLine || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={MdStreetview} mr={1} />
                          City:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.address?.city || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={FaFlag} mr={1} />
                          State:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.address?.state || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={FaGlobe} mr={1} />
                          Country:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.address?.country || 'N/A'}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontWeight="bold"
                          fontSize="sm"
                          color={labelColor}
                        >
                          <Icon as={MdConfirmationNumber} mr={1} />
                          Zipcode:
                        </Text>
                        <Text color={textColor}>
                          {selectedCompany?.address?.zipcode || 'N/A'}
                        </Text>
                      </Box>
                    </SimpleGrid>
                  </Box>
                </Box>

                {selectedCompany?.devices?.length > 0 && (
                  <>
                    <Divider my={6} />
                    <Box>
                      <Text
                        fontSize="lg"
                        fontWeight="bold"
                        mb={4}
                        color="orange.500"
                      >
                        <Icon as={MdDevices} mr={2} />
                        Assigned Devices
                      </Text>
                      <Table
                        variant="striped"
                        colorScheme="blue"
                        size="sm"
                        bg={sectionBg}
                        shadow="md"
                      >
                        <Thead>
                          <Tr>
                            <Th>Device Name</Th>
                            <Th>Product ID</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {selectedCompany.devices.map((device) => (
                            <Tr key={device._id}>
                              <Td>{device?.productName}</Td>
                              <Td>{device?.productId}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    </Box>
                  </>
                )}
              </Box>
            )}
          </ModalBody>

          <Box
            bg={addmodalheaderBg}
            py={3}
            px={6}
            textAlign="center"
            roundedBottom="lg"
            shadow="md"
          >
            <Button
              onClick={onViewClose}
              colorScheme="whiteAlpha"
              size="md"
              leftIcon={<CloseIcon />}
            >
              Close
            </Button>
          </Box>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Company;
